import { memo } from 'react';
import Loading from './Loading';

export default memo(Loading);
